/**
 * No hay formulario de usuario y clave: la consola delega el login en la
 * pantalla unica del SSO. Es lo que hace que la sesion sea compartida.
 */

import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Button } from '@presentation/components/common';
import { useAuthContext } from '@presentation/context/AuthContext';
import { routes } from '@presentation/router/routes';
import styles from '../admin.module.css';

export function LoginPage() {
  const { isAuthenticated, isLoading, login } = useAuthContext();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      void login();
    }
  }, [isLoading, isAuthenticated, login]);

  if (isAuthenticated) {
    return <Navigate to={routes.users} replace />;
  }

  return (
    <div className={styles.page}>
      <h1 className={styles.title}>Consola SSO</h1>
      <p className={styles.subtitle}>Redirigiendo al inicio de sesion unificado...</p>
      <div className={styles.toolbar}>
        <Button onClick={() => void login()}>Ir al login</Button>
      </div>
    </div>
  );
}
